<template>
<file-layout @download="onDownload" :file-name="fileName" :show-header="isPublic" :can-download="isPublic"
    :allow-share="false">
    <div class="viewbox">
      <audio v-if="link" autoplay="autoplay" controls="controls">
        <source :src="link" />
      </audio>
    </div>
  </file-layout>
</template>

<script>
import cookies from "js-cookie";
import { mapState } from "vuex";
import FileLayout from "@/components/h5/Layout";
export default {
  components: {
    FileLayout,
  },
  props: {
    rootId: {
      type: String,
    },
    fileId: {
      type: String,
    },
    metadata: {
      type: Object,
    },
    isPublic: {
      type: Boolean,
    },
  },
  data() {
    return {
      link: null,
    };
  },
  methods: {
    onDownload() {
      this.$emit("download", this.fileId);
    },

    getLink() {
      const key = `${this.rootId}-code`;
      const pass = cookies.get(key) || "";
      const inner = `${process.env.VUE_APP_INNERNET_URL}/file/preview/other/${this.fileId}`;
      const outer = `${process.env.VUE_APP_INNERNET_URL}/public/preview/${this.fileId}?rootId=${this.rootId}&password=${pass}&isPreview=true`;
      return this.isPublic ? outer : inner;
    },
  },

  computed: {
    ...mapState({
      isPcMode: (state) => state.isPcMode,
    }),

    fileName() {
      return this.metadata ? this.metadata?.fileName : "";
    },
  },

  mounted() {
    this.link = this.getLink();
  },
};
</script>

<style lang="scss" scoped>
.viewbox {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  audio {
    outline: none;
    border: none;

    &:focus {
      outline: none;
    }
  }
}
</style>
